const strings = {
  textModal: {
    ModalTitle: 'Cadastrar Nova Regra',
    ModalTitleEdit: 'Editar Regra',
  },
}

export default strings
